export default {

  dashboard: [],

  feedbacks: [],
  feedbackDetails: {},
  
  campaigns: [],
  campaignDetail: {},
  
  activeFeedback: [],

  creditTransaction: [],

  customerScore: [],

  scoreByCredit: null,

  getScoreData: {},


  vendorDetails: {},
  vendorScoreHistory: [],
  vendorDiscounts: [],

  privateDiscounts: [],
  publicDiscounts: [],

  scoreList: [],
  receivedScores: [],
  scoreDetails: {},
  scoreHistory: [],

  transactions: [],
  transaction: {},

};
